import { Placement } from '@amzn/fire-tv-campaign-automation-service';
import { KatDropdown } from '@amzn/katal-react';
import { StyledDropdown } from 'src/components/general/StyledDropdown';
import { useSelection } from 'src/contexts/SelectionContext';
import { PropUtils } from 'src/utils/PropUtils';

interface PlacementSelectorProps {}

const PlacementSelector = ({}: PlacementSelectorProps) => {
  const { placement, setPlacement } = useSelection();
  const handlePlacementChange = (event: KatDropdown.ChangeEvent) => {
    setPlacement(event.detail.value as Placement);
  };
  // ToDo: The list of applicable placements needs to be passed from CDK
  const placementOptions = PropUtils.createOptionsFromEnumValues([Placement.FEATURE_ROTATOR]);

  return (
    <StyledDropdown
      onChange={handlePlacementChange}
      options={placementOptions}
      label="Select Placement"
      style={{ marginRight: '25px' }}
      value={placement || Placement.FEATURE_ROTATOR}
    />
  );
};

export { PlacementSelector };
